"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllVaults = getAllVaults;
exports.getAllSingleAssetVaults = getAllSingleAssetVaults;
exports.getAllDoubleAssetVaults = getAllDoubleAssetVaults;
const maps_js_1 = require("./common/maps.js");
async function getAllVaults() {
    const vaultsArr = [];
    for (const pool of Object.keys(maps_js_1.poolInfo)) {
        vaultsArr.push(pool);
    }
    return vaultsArr;
}
async function getAllSingleAssetVaults() {
    const vaultsArr = [];
    for (const pool of Object.keys(maps_js_1.poolInfo)) {
        if (maps_js_1.poolInfo[pool].parentProtocolName === "NAVI" ||
            maps_js_1.poolInfo[pool].parentProtocolName === "BUCKET" ||
            maps_js_1.poolInfo[pool].parentProtocolName === "ALPHAFI" ||
            maps_js_1.poolInfo[pool].parentProtocolName === "ALPHALEND") {
            vaultsArr.push(pool);
        }
    }
    return vaultsArr;
}
async function getAllDoubleAssetVaults() {
    const vaultsArr = [];
    for (const pool of Object.keys(maps_js_1.poolInfo)) {
        if (maps_js_1.poolInfo[pool].parentProtocolName === "CETUS" ||
            maps_js_1.poolInfo[pool].parentProtocolName === "BLUEFIN") {
            vaultsArr.push(pool);
        }
    }
    return vaultsArr;
}
//# sourceMappingURL=getAllVaults.js.map